import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { logout, refreshSession, selectRelation } from '../actions/constants'
import { IAdviceProduct, IProduct } from '../../models/product'

export interface IProductsState {
  products: IProduct[]
  isLoading: boolean
  adviceProducts: IAdviceProduct[]
}

const initialState: IProductsState = {
  products: [],
  isLoading: false,
  adviceProducts: []
}

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<IProduct[]>) => {
      state.products = action.payload
    },
    setProduct: (state, action: PayloadAction<IProduct>) => {
      const index = state.products.findIndex(
        product => product.globalUid === action.payload.globalUid
      )

      if (index !== -1) {
        state.products[index] = action.payload
      } else {
        state.products.push(action.payload)
      }
    },
    setAdviceProducts: (state, action: PayloadAction<IAdviceProduct[]>) => {
      state.adviceProducts = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(logout, () => initialState)
      .addCase(selectRelation, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const { setProducts, setProduct, setIsLoading, setAdviceProducts } = productsSlice.actions

export default productsSlice.reducer
